import React from "react";
import { useSelector } from "react-redux";
import { Language } from "../../../redux/store/base/language";

import Logo from "./../../../assets/images/Logo.svg";

//Style
import {
  MDBListGroup,
  MDBListGroupItem,
  MDBCard,
  MDBCardHeader,
  MDBCardBody,
  MDBBtn,
} from "mdbreact";
import "./SideBarLeft.scss";

const SideBarLeft = (props: {}) => {
  const state = useSelector(
    (state: { lang: Language }) => state.lang.dictionary
  );

  return (
    <MDBListGroup className="side-left m-auto">
      <h4 className="mb-1">{state?.nextAppointments}</h4>
      <MDBListGroupItem className="top">
        <h5 className="mb-3 mt-3">{state?.today}</h5>
        <MDBCard>
          <MDBCardHeader className="d-flex">
            <div className="avtar">
              <img src={Logo} alt="" />
            </div>
            <div className="info">
              <p className="p-0 m-0 font-weight-bold">د. مصطفى محمد</p>
              <small>{state?.viewProfile}</small>
            </div>
            <div className="details mr-auto">
              <a href="#">{state?.details}</a>
            </div>
          </MDBCardHeader>
          <MDBCardBody>
            <p>10:00 AM - 11:00 AM (1 {state?.hour})</p>
            <MDBBtn>{state?.videoConsultation}</MDBBtn>
          </MDBCardBody>
        </MDBCard>
        <h5 className="mb-3 mt-4">{state?.tomorrow}</h5>
        <MDBCard>
          <MDBCardHeader className="d-flex">
            <div className="avtar">
              <img src={Logo} alt="" />
            </div>
            <div className="info">
              <p className="p-0 m-0 font-weight-bold">د. مصطفى محمد</p>
              <small>{state?.viewProfile}</small>
            </div>
            <div className="details mr-auto">
              <a href="#">{state?.details}</a>
            </div>
          </MDBCardHeader>
          <MDBCardBody>
            <p>10:00 AM - 11:00 AM (1 {state?.hour})</p>
            <MDBBtn>{state?.videoConsultation}</MDBBtn>
          </MDBCardBody>
        </MDBCard>
      </MDBListGroupItem>
    </MDBListGroup>
  );
};

export default SideBarLeft;
